module.exports = __webpack_public_path__ + "static/media/CSL-Esports-Privacy-Policy-v1.490fa71f.pdf";